import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import SessionActions from 'reducers/session';

import { SIGN_IN } from 'utils/routes';

const mapStateToProps = ({ profile }) => ({
  isDoneProfile: profile.isDoneProfile,
  isLoggedIn: profile.loggedIn,
  profile,
});

const mapDispatchToProps = ((dispatch) => ({
  goToSignIn: () => dispatch(push(SIGN_IN)),
  signOut: () => dispatch(SessionActions.signOut(true)),
}));

export default connect(mapStateToProps, mapDispatchToProps);
